/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonCovenantCommitteeTrxBtcInfo = {
    TRXHA: string;
    STAT: BabylonCovenantCommitteeTrxBtcInfo.STAT;
    SIGHA: string;
    BNO: string;
    AGE: string;
    UT: number;
};

export namespace BabylonCovenantCommitteeTrxBtcInfo {

    export enum STAT {
        SIGNED = 'SIGNED',
        MISSED = 'MISSED',
    }


}

